import { createServer } from 'miragejs'
import appConfig from 'configs/app.config'

import { signInUserData } from './data/authData'
import { schedulesData } from './data/scheduleData'
import { availabilitiesData } from './data/availabilityData'
import { trailsData } from './data/trailData'

import {
    authFakeApi,
    scheduleFakeApi,
    availabilityFakeApi,
    trailFakeApi,
} from './fakeApi'

const { apiPrefix } = appConfig

export default function mockServer({ environment = 'test' }) {
    return createServer({
        environment,
        seeds(server) {
            server.db.loadData({
                signInUserData,
                schedulesData,
                availabilitiesData,
                trailsData,
            })
        },
        routes() {
            this.urlPrefix = ''
            this.namespace = ''
            this.passthrough((request) => {
                let isExternal = request.url.startsWith('http')
                return isExternal
            })
            this.passthrough()

            authFakeApi(this, apiPrefix)
            scheduleFakeApi(this, apiPrefix)
            availabilityFakeApi(this, apiPrefix)
            trailFakeApi(this, apiPrefix)
        },
    })
}
